/* eslint-disable */
export default {
  inAMeeting: 'In een meeting',
  onMyWay: 'Onderweg',
  callMeBackIn: 'Bel me terug over',
  willCallYouBackIn: 'Ik bel u terug over',
  hour: 'uur',
  min: 'min.',
} as const;

// @key: @#@"inAMeeting"@#@ @source: @#@"In a meeting"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in..."@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in..."@#@
// @key: @#@"hour"@#@ @source: @#@"hour"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
